export let events;
(function (events) {
  events["embedPointsPageView"] = "embedPointsPageView";
  events["embedPointsInteraction"] = "embedPointsInteraction";
  events["paymentsInterstitialModalInteraction"] = "paymentsInterstitialModalInteraction";
  events["paymentsInterstitialModalView"] = "paymentsInterstitialModalView";
})(events || (events = {}));